(function () {
  'use strict';

  angular.module('app').component('creditNoteDetail', creditNoteDetail());

  function creditNoteDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        showActionsFromModal: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: CreditNoteDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/credit-notes/credit-note-detail/credit-note-detail.component.html',
    };
  }

  CreditNoteDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'AbilityService',
    'moment',
    '$routeParams',
    'CreditNoteService',
    'InvoiceService',
    'ClientService',
    'TaxService',
    'DocumentTypeService',
    'MeasurementUnitService',
    'DocumentService',

    // Angular downgraded service
    'companyService',
  ];

  function CreditNoteDetailComponent(
    config,
    UtilService,
    SessionService,
    AbilityService,
    moment,
    $routeParams,
    CreditNoteService,
    InvoiceService,
    ClientService,
    TaxService,
    DocumentTypeService,
    MeasurementUnitService,
    DocumentService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_creditnote_accountadmin'),
      canUpdate: AbilityService.can('update_creditnote_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.statusDraft = 'draft';
    vm.statusProcessed = 'processed';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';
    // vm.statusPaid      = 'paid';

    vm.creditNotFromInvoice = false;

    // private properties
    // -----------------------
    let company = SessionService.getSelectedAccountCompany();
    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      if (vm.item.id) {
        // view - edit
        if (!vm.item.user_id) {
          vm.item.user_id = SessionService.currentUser().id;
        }

        vm.isElectronicDocument = vm.item.document_type.numbering_type === 'electronic';

        // vm.loadingCreditNoteProducts = true; // !important
        setItemOptions(vm.item, vm.mode);

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          date: moment(),
          credit_note_reference: {},
          credit_note_products: [],
          payment_method_codes: [],
          // status: vm.statusDraft,
          company_id: company.id,
          user_id: SessionService.currentUser().id,
        };

        vm.sendCreditNoteToClient = false;

        // Initializers
        getDocumentTypes();

        vm.documentDate = moment();
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------

    // Atv functions
    vm.resendDocumentToAtv = function () {
      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(vm.item, 'credit_notes').then(function (data) {
        if (data) {
          vm.item.atv_status = data.atv_status || vm.item.atv_status; // Important if no atv status sent
        }

        vm.loadingDocument = false;
      });
    };

    vm.downloadCreditNotePdf = function () {
      CreditNoteService.downloadCreditNotePdf(vm.item, userLanguageCode);
    };

    vm.notifyDocumentToClient = function () {
      if (
        vm.item.status !== vm.statusProcessed ||
        (vm.atvCrEnabled && vm.item.atv_status !== vm.statusAccepted)
      )
        return;

      const successCallBack = function (email) {
        vm.item.client_email_receipt = email;

        vm.loadingDocument = true;
        DocumentService.notifyDocumentToClient(vm.item, 'credit_notes', email).then(function () {
          vm.loadingDocument = false;
        });
      };

      DocumentService.openNotifyDocumentToClient(
        vm.item.client.email,
        successCallBack,
        'SEND_CREDIT_NOTE_TO_CLIENT'
      );
    };

    vm.openRelatedTransactions = function () {
      CreditNoteService.openRelatedTransactions(vm.item, vm.item.client);
    };

    vm.isInvalidHeader = function () {
      if (vm.viewMode) return false;

      if (
        vm.sendingForm ||
        !(
          vm.item.client_id &&
          vm.item.invoice_id &&
          vm.item.credit_note_reference.reference_code &&
          vm.item.user_id &&
          vm.item.date
        )
      ) {
        return true;
      }

      return false;
    };

    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;

      setCreditNoteDatePicker(vm.documentType);
    };

    vm.onClientSelected = function (client) {
      let selectClientCallback = function () {
        vm.lastClientId = client.id;
        vm.item.client_id = client.id;
        vm.item.client = client;

        vm.item.invoice_id = null;
        vm.lastInvoiceId = null;

        getOpenInvoicesByClient(client.id);
      };

      // Delete credit note products for draft credit note if change client, when the credit note has credit note products
      if (
        vm.item.status === vm.statusDraft &&
        vm.item.credit_note_products.length > 0 &&
        vm.lastClientId &&
        client.id !== vm.lastClientId
      ) {
        let successCallback = function () {
          vm.item.credit_note_products = [];

          selectClientCallback();

          return;
        };

        let cancelCallback = function () {
          // Just to keep current client
          vm.item.client_id = vm.lastClientId;
        };

        // CreditNoteService.removeCreditNoteItems(successCallback, cancelCallback);
        let modalParams = {
          title: 'CHANGE_CLIENT_FOR_CURRENT_CREDIT_NOTE',
          body: 'CHANGE_CLIENT_FOR_CURRENT_CREDIT_NOTE_WARNING',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        // In case the user change the client
        if (vm.lastClientId && client.id !== vm.lastClientI) {
          vm.item.credit_note_products = [];
        }

        selectClientCallback();
      }
    };

    // When client is empty
    vm.onClientValidated = function (client) {
      vm.item.client = client;

      if (!vm.item.client && vm.item.client_id) {
        resetClientInput();
      }
    };

    vm.onClientCleared = function (clearObj) {
      if (clearObj) {
        vm.item.client = null;
      }

      resetClientInput();
    };

    vm.selectCreditNoteReason = function (referenceCode) {
      vm.referenceCode = referenceCode;
      vm.item.credit_note_reference.reference_reason = referenceCode.name;

      vm.item.edit_allowed = referenceCode.code === '01' ? false : referenceCode.allow_edit;
    };

    vm.selectOpenInvoice = function (invoiceId) {
      // Same open invoice selected
      if (vm.lastInvoiceId === invoiceId) return;

      vm.allProductsCabysCodeSet = true;

      vm.loadingCreditNoteProducts = true;
      InvoiceService.getInvoice(invoiceId).then(function (invoice) {
        vm.lastInvoiceId = invoice.id;

        vm.item.unit_price_type = invoice.unit_price_type;

        vm.item.subtotal_services_taxable = invoice.subtotal_services_taxable;
        vm.item.subtotal_services_exempt = invoice.subtotal_services_exempt;
        vm.item.subtotal_services_exonerable = invoice.subtotal_services_exonerable;
        vm.item.subtotal_goods_taxable = invoice.subtotal_goods_taxable;
        vm.item.subtotal_goods_exempt = invoice.subtotal_goods_exempt;
        vm.item.subtotal_goods_exonerable = invoice.subtotal_goods_exonerable;

        vm.item.total_taxable = invoice.total_taxable;
        vm.item.total_exempt = invoice.total_exempt;
        vm.item.total_exonerable = invoice.total_exonerable;
        vm.item.total_sale = invoice.total_sale;
        vm.item.total_discount = invoice.total_discount;
        vm.item.total_net_sale = invoice.total_net_sale;

        vm.item.total_taxes = invoice.total_taxes;
        vm.item.total_tax_exonerations = invoice.total_tax_exonerations;
        vm.item.total_net_taxes = invoice.total_net_taxes;
        vm.item.total_retornable_taxes = invoice.total_retornable_taxes;
        vm.item.total_other_charges = invoice.total_other_charges;
        vm.item.grand_total = invoice.grand_total;
        // balance ?

        vm.item.user_id = invoice.user_id || SessionService.currentUser().id;
        vm.item.sale_channel_id = invoice.sale_channel_id;
        vm.item.sale_source_id = invoice.sale_source_id;
        vm.item.sale_condition_code = invoice.sale_condition_code;
        vm.item.payment_method_code = invoice.payment_method_code;
        vm.item.payment_method_id = invoice.payment_method_id;
        vm.item.credit_payment_days = invoice.credit_payment_days;

        vm.item.invoice_id = invoice.id;
        vm.item.currency_id = invoice.currency_id;
        vm.item.currency = invoice.currency;
        vm.item.credit_note_products = [];

        vm.item.exchange_rate_value = invoice.exchange_rate_value;
        vm.item.base_currency_symbol = invoice.base_currency_symbol;

        vm.item.credit_note_reference = {
          reference_doc_type: invoice.type,
          reference_date: invoice.date,
          reference_number: invoice.invoice_number,
          reference_key: invoice.atv_cr_key,
        };

        if (vm.item.sale_condition_code) {
          // vm.saleCondition = vm.UtilService.findItemInArray(vm.company.sale_conditions, 'code', vm.item.sale_condition_code);
          vm.saleCondition = vm.company.sale_conditions.find(
            (item) => item.code === vm.item.sale_condition_code
          );
        }

        invoice.invoice_products.forEach(function (invoice_product) {
          let measurementUnit = vm.company.measurement_units.find(
            (item) => item.id === invoice_product.measurement_unit_id
          );

          let creditNoteProduct = {
            product_id: invoice_product.product_id,
            product_code: invoice_product.product_code,
            product_cabys_code: invoice_product.product_cabys_code,
            product_name: invoice_product.product_name,
            product_type: invoice_product.product_type,

            quantity: invoice_product.quantity,
            unit_price: invoice_product.unit_price,
            total_amount: invoice_product.total_amount,
            discount_percentage: invoice_product.discount_percentage,
            discount_amount: invoice_product.discount_amount,
            subtotal_price: invoice_product.subtotal_price,

            tax_percentage: invoice_product.tax_percentage,
            tax_amount: invoice_product.tax_amount,
            tax_exoneration_percentage: invoice_product.tax_exoneration_percentage,
            tax_exoneration_amount: invoice_product.tax_exoneration_amount,
            net_tax_percentage: invoice_product.net_tax_percentage,
            net_tax_amount: invoice_product.net_tax_amount,
            total_price: invoice_product.total_price,

            remarks: invoice_product.remarks,

            measurement_unit_id: invoice_product.measurement_unit_id,
            measurement_unit_symbol: invoice_product.measurement_unit_symbol,
            measurement_unit: measurementUnit,

            transaction_taxes: invoice_product.transaction_taxes,

            product: invoice_product.product,
          };

          getTaxesPerProduct(creditNoteProduct, invoice_product.product);

          if (vm.atvCrEnabled && vm.isElectronicDocument && !creditNoteProduct.product_cabys_code) {
            vm.allProductsCabysCodeSet = false;
          }

          vm.item.credit_note_products.push(creditNoteProduct);
        });

        vm.loadingCreditNoteProducts = false;
      });
    };

    vm.openClientInfoModal = function (client) {
      ClientService.openClientInfoModal(client);
    };

    vm.editCreditNoteProductRemarks = function (creditNoteProduct) {
      vm.creditNoteProduct = creditNoteProduct;
    };

    vm.calculateCreditNoteProductTotalPrice = function (creditNoteProduct) {
      creditNoteProduct.quantity = creditNoteProduct.quantity || 1;
      creditNoteProduct.tax_percentage = creditNoteProduct.tax_percentage || 0;

      let unitPrice = 0; // '' 0
      let discountPercentage = 0;

      if (vm.item.unit_price_type) {
        unitPrice = creditNoteProduct.unit_price; // || 0
        discountPercentage = creditNoteProduct.discount_percentage || 0;
      } else {
        creditNoteProduct.total_price = creditNoteProduct.total_price || 0;

        //  Unit price is calculated as Total divided by quantity before taxes
        let basePrice =
          creditNoteProduct.total_price / (creditNoteProduct.tax_percentage / 100 + 1); // vm.UtilService.roundNum(

        // TODO. exonerations ??

        unitPrice = basePrice / creditNoteProduct.quantity;
      }

      let totalAmount = creditNoteProduct.quantity * unitPrice;
      let discountAmount = totalAmount * (discountPercentage / 100);
      let subtotalPrice = totalAmount - discountAmount;

      creditNoteProduct.transaction_taxes = TaxService.setProductTaxesAmounts(
        subtotalPrice,
        creditNoteProduct.productTaxes
      );

      // console.log(creditNoteProduct.productTaxes);
      // console.log(creditNoteProduct.transaction_taxes);

      let taxAmount = TaxService.getProductTaxesTotalAmount(creditNoteProduct.transaction_taxes);
      let taxExonerationAmount = TaxService.getProductTaxesTotalExonerationAmount(
        creditNoteProduct.transaction_taxes
      );
      let netTaxAmount = taxAmount - taxExonerationAmount;

      if (unitPrice) {
        creditNoteProduct.unit_price = vm.UtilService.roundNum(unitPrice);
      }

      creditNoteProduct.total_amount = vm.UtilService.roundNum(totalAmount);
      creditNoteProduct.discount_percentage = discountPercentage;
      creditNoteProduct.discount_amount = vm.UtilService.roundNum(discountAmount);
      creditNoteProduct.subtotal_price = vm.UtilService.roundNum(subtotalPrice);

      creditNoteProduct.tax_amount = vm.UtilService.roundNum(taxAmount);
      creditNoteProduct.tax_exoneration_amount = vm.UtilService.roundNum(taxExonerationAmount);
      creditNoteProduct.net_tax_amount = vm.UtilService.roundNum(netTaxAmount);

      if (vm.item.unit_price_type) {
        creditNoteProduct.total_price = vm.UtilService.roundNum(subtotalPrice + netTaxAmount); // taxAmount
      }

      calculateCreditNoteTotals();
    };

    vm.editCreditNote = function () {
      vm.editMode = true;
      vm.viewMode = false;

      getDocumentTypes();
      vm.selectCreditNoteReason(vm.referenceCode);
    };

    /*vm.cancelEdit = function() {
            vm.item = vm.originalItem;

            setItemOptions(vm.item);
            setCreditNoteProducts();
        };*/

    vm.saveCreditNote = function (isFormValid, status) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      if (!vm.allProductsCabysCodeSet) return;

      let createCreditNote = function () {
        if (vm.item.payment_method_code) {
          vm.item.payment_method_codes.push(vm.item.payment_method_code);
        }

        vm.item.status = status;

        let creditNote = setCreditNoteParams();

        // console.log(creditNote); return;

        vm.sendingForm = true;
        CreditNoteService.saveCreditNote(creditNote).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // success
            if (!vm.editMode) {
              // create
              vm.onSavedItem({ item: response });
            } else {
              setItemOptions(response);
            }
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        });
      };

      if (status !== vm.statusDraft && vm.sendCreditNoteToClient) {
        let successCallBack = function (email) {
          vm.item.client_email_receipt = email;

          createCreditNote();
        };

        CreditNoteService.openSendCreditNoteToClient(vm.item.client.email, successCallBack);
      } else {
        vm.item.client_email_receipt = vm.item.client.email;

        createCreditNote();
      }
    };

    vm.cancel = function () {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem();
    };

    /*vm.convertAmountToBaseAccountingCurrency = function(amount) {
            if(!vm.item.exchange_rate_value){
                return 0;
            }
            return vm.UtilService.roundNum(amount * vm.item.exchange_rate_value);
        };*/

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editCreditNote();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    // Initializers
    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      vm.loadingCompany = true;

      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;

          if (vm.company.country.country_setting) {
            vm.company.credit_note_reference_codes =
              vm.company.country.country_setting.credit_note_reference_codes;
          }

          if (vm.createMode) {
            vm.companyActivityCode = vm.company.activity_codes.find(
              (activity_code) => activity_code.id === vm.company.company_activity_code_id
            );
            vm.item.company_activity_code = vm.companyActivityCode.code;

            if ($routeParams && $routeParams.invoiceId) {
              vm.item.invoice_id = $routeParams.invoiceId;
              vm.item.invoice = {
                invoice_number: $routeParams.invoiceNumber,
              };

              getClient($routeParams.clientId);

              vm.selectOpenInvoice($routeParams.invoiceId);

              vm.creditNotFromInvoice = true;
            }
          } else {
            // View / Edit
            setCompanyActivityCode(vm.company);

            if (vm.editMode) {
              vm.item.currency_id = vm.item.client.currency_id
                ? vm.item.client.currency_id
                : vm.companyBaseCurrencyId;
              vm.item.currency = vm.currenciesPerCompany.find((x) => x.id === vm.item.currency_id);

              // vm.item.currency = vm.UtilService.findItemInArray(vm.currenciesPerCompany, 'id', vm.item.client.currency_id);
            }

            vm.saleCondition = vm.company.sale_conditions.find(
              (x) => x.code === vm.item.sale_condition_code
            );

            if (vm.item.payment_method_code) {
              vm.paymentMethod = vm.company.payment_methods.find(
                (x) => x.code === vm.item.payment_method_code
              );
            }

            if (vm.company.country.country_setting) {
              // vm.referenceCode = vm.UtilService.findItemInArray(
              //     vm.company.credit_note_reference_codes, 'code', vm.item.credit_note_reference.reference_code
              // );

              vm.referenceCode = vm.company.credit_note_reference_codes.find(
                (x) => x.code === vm.item.credit_note_reference.reference_code
              );
            }

            vm.user = vm.company.users.find((x) => x.id === vm.item.user_id);

            setCreditNoteProducts();
          }

          vm.loadingCompany = false;
        });
    }

    function setCompanyActivityCode(company) {
      if (!vm.atvCrEnabled) return;

      let activityCode = company.activity_codes.find((activityCode) => {
        return (
          activityCode.code === vm.item.company_activity_code ||
          activityCode.id === vm.item.company_activity_code_id
        );
      });

      vm.companyActivityCode = activityCode;
      vm.item.company_activity_code = activityCode.code;
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'client_credit_notes',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          let defaultDocumentType = vm.documentTypes.find(
            (documentType) => documentType.is_default
          );
          vm.documentType = defaultDocumentType ? defaultDocumentType : vm.documentTypes[0];
          vm.item.document_type_id = vm.documentType.id;
        } else {
          vm.documentType = vm.documentTypes.find(
            (documentType) => documentType.id === vm.item.document_type_id
          );
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        vm.isElectronicDocument = vm.documentType.numbering_type === 'electronic';

        setCreditNoteDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function resetClientInput() {
      vm.item.client_id = null;
      vm.item.currency_id = null;
      vm.item.sale_condition_code = null;
      vm.item.credit_payment_days = null;
      vm.item.due_date = null;

      if (vm.item.payment_method_code) {
        vm.item.payment_method_code = null;
        vm.item.payment_method_id = null;
      }

      vm.item.credit_note_products = []; // check
    }

    function getTaxesPerProduct(creditNoteProduct, product) {
      product = vm.editMode ? creditNoteProduct.product : product;

      let documentDate = vm.item.date;

      creditNoteProduct.productTaxes = TaxService.setProductTaxes(product, documentDate).saleTaxes;

      // let productTaxes = TaxService.setProductTaxes(product, documentDate).saleTaxes;

      // if (productTaxes) {
      //     creditNoteProduct.transaction_taxes = productTaxes;
      // }
    }

    function calculateCreditNoteTotals() {
      let subtotal_services_taxable = 0;
      let subtotal_services_exempt = 0;
      let subtotal_services_exonerable = 0;
      let subtotal_goods_taxable = 0;
      let subtotal_goods_exempt = 0;
      let subtotal_goods_exonerable = 0;

      let total_sale = 0;
      let total_discount = 0;
      let total_net_sale = 0;
      let total_taxes = 0;
      let total_tax_exonerations = 0;
      let total_net_taxes = 0;
      let grand_total = 0;

      vm.item.credit_note_products.forEach(function (credit_note_product) {
        let total_amount = credit_note_product.total_amount;

        // if (credit_note_product.tax_amount > 0) {
        if (!credit_note_product.is_exempt) {
          if (
            credit_note_product.measurement_unit &&
            credit_note_product.measurement_unit.is_a_service
          ) {
            if (credit_note_product.tax_exoneration_amount > 0) {
              subtotal_services_taxable +=
                (1 -
                  (credit_note_product.tax_exoneration_percentage * 1) /
                    credit_note_product.tax_percentage) *
                total_amount;
              subtotal_services_exonerable += total_amount - subtotal_services_taxable;
            } else {
              subtotal_services_taxable += total_amount;
            }
          } else {
            if (credit_note_product.tax_exoneration_amount > 0) {
              subtotal_goods_taxable +=
                (1 -
                  (credit_note_product.tax_exoneration_percentage * 1) /
                    credit_note_product.tax_percentage) *
                total_amount;
              subtotal_goods_exonerable += total_amount - subtotal_goods_taxable;
            } else {
              subtotal_goods_taxable += total_amount;
            }
          }
        } else {
          if (
            credit_note_product.measurement_unit &&
            credit_note_product.measurement_unit.is_a_service
          ) {
            subtotal_services_exempt += total_amount;
          } else {
            subtotal_goods_exempt += total_amount;
          }
        }

        total_sale += credit_note_product.total_amount;
        total_discount += credit_note_product.discount_amount;
        total_net_sale += credit_note_product.subtotal_price;
        total_taxes += credit_note_product.tax_amount;
        total_tax_exonerations += credit_note_product.tax_exoneration_amount;
        total_net_taxes += credit_note_product.net_tax_amount;
        grand_total += credit_note_product.total_price;
      });

      // check these values with Pablo
      let total_taxable = subtotal_services_taxable + subtotal_goods_taxable;
      let total_exempt = subtotal_services_exempt + subtotal_goods_exempt;
      let total_exonerable = subtotal_services_exonerable + subtotal_goods_exonerable;
      let total_retornable_taxes = 0;
      let total_other_charges = 0;

      vm.item.subtotal_services_taxable = vm.UtilService.roundNum(subtotal_services_taxable);
      vm.item.subtotal_services_exempt = vm.UtilService.roundNum(subtotal_services_exempt);
      vm.item.subtotal_services_exonerable = vm.UtilService.roundNum(subtotal_services_exonerable);
      vm.item.subtotal_goods_taxable = vm.UtilService.roundNum(subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = vm.UtilService.roundNum(subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = vm.UtilService.roundNum(subtotal_goods_exonerable);

      vm.item.total_taxable = vm.UtilService.roundNum(total_taxable);
      vm.item.total_exempt = vm.UtilService.roundNum(total_exempt);
      vm.item.total_exonerable = vm.UtilService.roundNum(total_exonerable);
      vm.item.total_sale = vm.UtilService.roundNum(total_sale);
      vm.item.total_discount = vm.UtilService.roundNum(total_discount);
      vm.item.total_net_sale = vm.UtilService.roundNum(total_net_sale);

      vm.item.total_taxes = vm.UtilService.roundNum(total_taxes);
      vm.item.total_tax_exonerations = vm.UtilService.roundNum(total_tax_exonerations);
      vm.item.total_net_taxes = vm.UtilService.roundNum(total_net_taxes);
      vm.item.total_retornable_taxes = vm.UtilService.roundNum(total_retornable_taxes);
      vm.item.total_other_charges = vm.UtilService.roundNum(total_other_charges);
      vm.item.grand_total = vm.UtilService.roundNum(grand_total);
      vm.item.balance_due = vm.item.grand_total;
    }

    // Remove unnecessary params
    function setCreditNoteParams() {
      let creditNote = angular.copy(vm.item);

      delete creditNote.currency;
      delete creditNote.client;
      delete creditNote.edit_allowed;

      // Delete this when multiple payment methods are allowed
      // creditNote.payment_method_codes.push(vm.item.payment_method_code);
      // creditNote.payment_method = vm.saleCondition.value;

      creditNote.credit_note_products.forEach(function (product) {
        delete product.$$hashKey;
        delete product.measurement_unit;
        delete product.product;
      });

      return creditNote;
    }

    function getClient(clientId) {
      ClientService.getClient(clientId, { skip_check_role: true }).then(function (data) {
        vm.item.client_id = data.id;
        vm.item.client = data;
      });
    }

    function getOpenInvoicesByClient(clientId) {
      let params = {
        get: 'open_invoices', // paid / accepted
        client_id: clientId,
        atvCrEnabled: vm.atvCrEnabled,
        by_reference_date: vm.item.date,
        skip_check_role: true,
      };

      vm.loadingOpenInvoices = true;
      InvoiceService.getInvoices(params).then(function (data) {
        vm.openInvoices = data.items;

        vm.loadingOpenInvoices = false;
      });
    }

    function setCreditNoteProducts() {
      vm.loadingCreditNoteProducts = false;

      if (vm.item.credit_note_products.length === 0) return;

      vm.allProductsCabysCodeSet = true;

      vm.item.credit_note_products.forEach(function (creditNoteProduct) {
        let measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          creditNoteProduct.product_type
        );

        // var measurementUnit = vm.UtilService.findItemInArray(
        //     measurementUnits, 'id', creditNoteProduct.measurement_unit_id
        // );

        let measurementUnit = measurementUnits.find(
          (item) => item.id === creditNoteProduct.measurement_unit_id
        );

        selectMeasurementUnit(creditNoteProduct, measurementUnit);

        if (vm.atvCrEnabled && vm.isElectronicDocument && !creditNoteProduct.product_cabys_code) {
          vm.allProductsCabysCodeSet = false;
        }

        // If product is related to booking item - what for ????
        /*if (creditNoteProduct.booking_item_id) {
                    creditNoteProduct.booking_item_unit_price  = creditNoteProduct.unit_price;
                    creditNoteProduct.booking_item_total_price = creditNoteProduct.total_price;
                }*/
      });
    }

    function selectMeasurementUnit(creditNoteProduct, measurementUnit) {
      creditNoteProduct.measurement_unit = measurementUnit;
      creditNoteProduct.measurement_unit_symbol = measurementUnit.symbol;
    }

    function setCreditNoteDatePicker(documentType) {
      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        getOpenInvoicesByClient(vm.item.client_id);
      };

      vm.datePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }
  }
})();
